<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb -->
    <div class="mb-3 row">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { p_idtramite } }">
                Trámite N.° {{ p_idtramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Top Observaciones — Trámite N.° {{ p_idtramite }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="card border-0 mb-3" style="background-color: #e8f4fd;">
      <div class="card-body py-2 px-3">
        <span class="text-dark fw-bold">{{ datosTramite }}</span>
      </div>
    </div>

    <!-- Filtros -->
    <div class="row g-2 align-items-end mb-3">
      <div class="col-auto">
        <label class="form-label mb-0 small fw-bold">Tipo de observación</label>
        <select v-model="tipoSeleccionado" class="form-select form-select-sm" @change="cargarDatos">
          <option value="">Seleccione...</option>
          <option value="M">Auditoría Médica</option>
          <option value="D">Gestión Documental</option>
        </select>
      </div>
      <div class="col-auto">
        <label class="form-label mb-0 small fw-bold">Mostrar top</label>
        <select v-model.number="topN" class="form-select form-select-sm" style="width: 80px;">
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
          <option :value="9999">Todos</option>
        </select>
      </div>
      <div class="col-auto">
        <button
          @click="cargarDatos"
          class="btn btn-primary btn-sm d-flex align-items-center gap-1"
          :disabled="!tipoSeleccionado || cargando"
        >
          <span class="material-icons" style="font-size: 16px">refresh</span>
          Actualizar
        </button>
      </div>
      <div class="col-auto ms-auto">
        <button
          @click="exportToExcel"
          class="btn btn-info btn-sm d-flex align-items-center gap-1"
          :disabled="topLista.length === 0"
        >
          <span class="material-icons" style="font-size: 16px">download</span>
          Excel
        </button>
      </div>
    </div>

    <!-- Cargando -->
    <div v-if="cargando" class="alert alert-info py-2 px-3" role="alert">
      Cargando datos...
    </div>

    <div v-else>

      <!-- Sin datos -->
      <div v-if="topLista.length === 0" class="alert alert-warning">
        No hay datos para mostrar.
      </div>

      <div v-else>

        <!-- Tarjetas resumen -->
        <div class="row g-3 mb-4">
          <div class="col-auto">
            <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 140px;">
              <div class="small text-muted fw-bold">Total registros</div>
              <div class="fs-4 fw-bold text-dark">{{ datos.length }}</div>
            </div>
          </div>
          <div class="col-auto">
            <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 140px;">
              <div class="small text-muted fw-bold">Tipos distintos</div>
              <div class="fs-4 fw-bold text-primary">{{ rankingCompleto.length }}</div>
            </div>
          </div>
          <div class="col-auto">
            <div class="card border-0 shadow-sm px-3 py-2 text-center" style="min-width: 200px;">
              <div class="small text-muted fw-bold">Más frecuente</div>
              <div class="small fw-bold text-danger" style="max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                :title="rankingCompleto[0]?.observacionEstandar">
                {{ rankingCompleto[0]?.observacionEstandar || '—' }}
              </div>
              <div class="fs-5 fw-bold text-danger">{{ rankingCompleto[0]?.cantidad || 0 }} veces</div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'grafico' }"
              href="#" @click.prevent="activeTab = 'grafico'">
              <span class="material-icons align-middle me-1" style="font-size: 16px">bar_chart</span>
              Gráfico
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'tabla' }"
              href="#" @click.prevent="activeTab = 'tabla'">
              <span class="material-icons align-middle me-1" style="font-size: 16px">table_chart</span>
              Tabla
            </a>
          </li>
        </ul>

        <!-- ══════════════════════════════════════════════ -->
        <!-- Tab: Gráfico                                   -->
        <!-- ══════════════════════════════════════════════ -->
        <div v-if="activeTab === 'grafico'">
          <div
            v-for="(item, idx) in topLista"
            :key="item.observacionEstandar"
            class="mb-3"
          >
            <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
              <div class="d-flex align-items-center gap-2" style="min-width: 0;">
                <span class="badge bg-secondary" style="min-width: 28px;">{{ idx + 1 }}</span>
                <span class="small fw-bold text-truncate" :title="item.observacionEstandar"
                  style="max-width: 500px;">
                  {{ item.observacionEstandar }}
                </span>
              </div>
              <span class="small text-muted text-nowrap">
                {{ item.cantidad }} ({{ item.porcentaje }}%)
              </span>
            </div>
            <div class="progress" style="height: 20px; border-radius: 4px; background-color: #dee2e6;">
              <div
                class="progress-bar"
                :style="{
                  width: item.porcentaje + '%',
                  backgroundColor: colorBarra(idx),
                  transition: 'width 0.6s ease',
                }"
                :title="`${item.observacionEstandar}: ${item.cantidad}`"
              >
                <span v-if="item.porcentaje > 8" class="small fw-bold">
                  {{ item.porcentaje }}%
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- ══════════════════════════════════════════════ -->
        <!-- Tab: Tabla                                     -->
        <!-- ══════════════════════════════════════════════ -->
        <div v-if="activeTab === 'tabla'">
          <div class="table-responsive">
            <table class="table table-hover table-bordered table-sm">
              <thead class="table-dark">
                <tr>
                  <th style="width: 50px;">#</th>
                  <th class="th-sort" @click="ordenarTabla('observacionEstandar')">
                    Observación estándar
                    <span>{{ iconOrdenTabla('observacionEstandar') }}</span>
                  </th>
                  <th class="th-sort" @click="ordenarTabla('cantidad')" style="width: 100px;">
                    Cantidad <span>{{ iconOrdenTabla('cantidad') }}</span>
                  </th>
                  <th class="th-sort" @click="ordenarTabla('porcentaje')" style="width: 100px;">
                    % <span>{{ iconOrdenTabla('porcentaje') }}</span>
                  </th>
                  <th style="min-width: 120px;">Proporción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in topListaOrdenada" :key="item.observacionEstandar">
                  <td class="text-center fw-bold text-muted small">{{ idx + 1 }}</td>
                  <td>{{ item.observacionEstandar }}</td>
                  <td class="text-center">
                    <span class="badge bg-primary">{{ item.cantidad }}</span>
                  </td>
                  <td class="text-center fw-bold" :class="colorPorcentaje(item.porcentaje)">
                    {{ item.porcentaje }}%
                  </td>
                  <td>
                    <div class="progress" style="height: 14px; border-radius: 3px;">
                      <div
                        class="progress-bar"
                        :style="{
                          width: item.porcentaje + '%',
                          backgroundColor: colorBarra(idx),
                        }"
                      ></div>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-secondary fw-bold">
                  <td></td>
                  <td>Total ({{ rankingCompleto.length }} tipos)</td>
                  <td class="text-center">
                    <span class="badge bg-primary">{{ datos.length }}</span>
                  </td>
                  <td class="text-center">100%</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import * as XLSX from "xlsx";

export default {
  name: "TopObservaciones",
  components: { Layout, Footer },

  props: {
    p_idtramite: { type: Number, required: true },
  },

  data() {
    return {
      tipoSeleccionado:  "",
      cargando:          false,
      activeTab:         "grafico",
      datos:             [],
      datosTramite:      "",
      topN:              10,
      // Ordenamiento tabla
      campoOrdenTabla:   "cantidad",
      ascendenteTabla:   false, // descendente por defecto (mayor primero)
    };
  },

  computed: {
    // ── Ranking completo agrupado por observacionEstandar ──
    rankingCompleto() {
      const mapa = {};
      this.datos.forEach(item => {
        const clave = item.observacionEstandar || '(Sin descripción)';
        mapa[clave] = (mapa[clave] || 0) + 1;
      });
      const total = this.datos.length || 1;
      return Object.entries(mapa)
        .map(([obs, cantidad]) => ({
          observacionEstandar: obs,
          cantidad,
          porcentaje: Math.round((cantidad / total) * 100),
        }))
        .sort((a, b) => b.cantidad - a.cantidad);
    },

    // ── Top N para el gráfico (siempre ordenado por cantidad desc) ──
    topLista() {
      return this.rankingCompleto.slice(0, this.topN);
    },

    // ── Top N para la tabla (con ordenamiento personalizable) ──
    topListaOrdenada() {
      const campo = this.campoOrdenTabla;
      return [...this.topLista].sort((a, b) => {
        const va = a[campo] ?? "";
        const vb = b[campo] ?? "";
        if (typeof va === 'number') {
          return this.ascendenteTabla ? va - vb : vb - va;
        }
        const cmp = String(va).localeCompare(String(vb), "es");
        return this.ascendenteTabla ? cmp : -cmp;
      });
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarDatos();
    this.datosTramite = sessionStorage.getItem("datosTramite");
  },

  methods: {
    async cargarDatos() {
      if (!this.tipoSeleccionado) return;
      this.cargando = true;
      try {
        const params = { idTramite: this.p_idtramite };
        if (this.tipoSeleccionado) params.tipo = this.tipoSeleccionado;
        const { data } = await api.get("/vwobservaciones/tramite-buscar-todos", { params });
        this.datos = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error("Error al cargar datos:", e);
        this.datos = [];
      } finally {
        this.cargando = false;
      }
    },

    // ── Ordenamiento tabla ───────────────────────────────
    ordenarTabla(campo) {
      if (this.campoOrdenTabla === campo) {
        this.ascendenteTabla = !this.ascendenteTabla;
      } else {
        this.campoOrdenTabla = campo;
        this.ascendenteTabla = campo === 'observacionEstandar';
      }
    },
    iconOrdenTabla(campo) {
      if (this.campoOrdenTabla !== campo) return "⇅";
      return this.ascendenteTabla ? "↑" : "↓";
    },

    // ── Colores ──────────────────────────────────────────
    colorBarra(idx) {
      const colores = [
        "#0d6efd", "#198754", "#dc3545", "#fd7e14",
        "#6f42c1", "#20c997", "#d63384", "#0dcaf0",
        "#6610f2", "#ffc107",
      ];
      return colores[idx % colores.length];
    },
    colorPorcentaje(pct) {
      if (pct >= 20) return "text-danger";
      if (pct >= 10) return "text-warning";
      return "text-success";
    },

    // ── Exportar Excel ────────────────────────────────────
    exportToExcel() {
      if (!this.topLista.length) return;
      const headers = ["#", "Observación estándar", "Cantidad", "%"];
      const data = this.topLista.map((item, idx) => [
        idx + 1,
        item.observacionEstandar,
        item.cantidad,
        item.porcentaje,
      ]);
      data.push(["", `Total (${this.rankingCompleto.length} tipos)`, this.datos.length, 100]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Top Observaciones");
      XLSX.writeFile(wb, `top_observaciones_${this.p_idtramite}.xlsx`);
    },
  },
};
</script>

<style scoped>
.nav-tabs .nav-link.active {
  background-color: #0d6efd;
  color: #fff !important;
  border-color: #0d6efd #0d6efd #fff;
}
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
</style>